import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import { getTestLabels } from '../../../utils/getTestLabels.js';
import style from './AutoshipmentLogoMark.module.scss.js';

const { componentTestLabel } = getTestLabels('AutoshipmentLogoMark');
/**
 * [design (Figma)](https://www.figma.com/file/XpsesTqoYjoiDj1pqxcDL5/Images%2C-Illustrations%E2%80%A8-%26-Logos?type=design&node-id=1235-317&mode=design&t=bAV3MOUKn6cBuY5w-0)
 * | [source code](https://src.private.zooplus.net/projects/FE/repos/ui-components/browse/src/components/Autoshipment/AutoshipmentLogoLockup/AutoshipmentLogoMark.tsx)
 *
 * @param {Realm} realm - (optional) One of `bitiba` or `zooplus` (defaults to `zooplus`).
 * @param {AutoshipmentLogoSizes} size - (optional) Size of the logo. One of `small` or `medium`. (defaults to `small`).
 * @param {('light')} variant - (optional) Can be set to `light` for usage on dark backgrounds.
 * @param {AutoshipmentLogoVerticalAlignments} verticalAlign - (optional) Applies a CSS `vertical-align` value. Can be one of `bottom`, `baseline`, `middle`, or `top`.
 */
const AutoshipmentLogoMark = (props) => {
    const { className, realm = 'zooplus', size, style: authorStyle, variant, verticalAlign, ...otherProps } = props;
    const squareDimensions = size === 'medium' ? '19' : '13';
    return (jsx("img", { "data-zta": componentTestLabel, loading: props.loading || 'lazy', src: `https://cdn.public.zooplus.net/media/ui-components/v6-latest/svg/autoship-logo-mark-${realm}.svg`, alt: props.alt || '', ...otherProps, className: classNames(className, style['z-autoshipment-logo-mark'], {
            [style['z-autoshipment-logo-mark--medium']]: size === 'medium',
            [style['z-autoshipment-logo-mark--light']]: variant === 'light',
        }), width: squareDimensions, height: squareDimensions, style: {
            ...authorStyle,
            '--pp-AutoshipmentLogoMark-valign': verticalAlign,
        } }));
};

export { AutoshipmentLogoMark };
//# sourceMappingURL=AutoshipmentLogoMark.js.map
